module.exports = __webpack_public_path__ + "img/ic_info1.47226d00.jpg";